<template>
    <div class="grid-container">
        <div class="grid-x grid-margin-x">
            <div class="small-10 small-offset-1 medium-6 medium-offset-3 cell">
                <form @submit.prevent="onSignUp">
                    <h3>Sign up</h3>
                    <input type="email" v-model="email" placeholder="Email">
                    <input type="password" v-model="password" placeholder="Password">
                    <button class="button expanded">Sign up</button><br>
                    <router-link to="/login">Log in to your account</router-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name: 'signUp',
    data () {
        return {
            email: '',
            password: ''
        }
    },
    computed: {
        user () {
            return this.$store.getters.user
        }
    },
    watch: {
        user (value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        onSignUp () {
            this.$store.dispatch('signUserUp', {email: this.email, password: this.password})
        }
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// SignUp.vue?6dfe940d